/**
 * RCP Live Pricing — pulls QBO prices on every page load
 * Any element with data-qbo-name="<exact QBO item name>" gets its
 * textContent replaced with the live price (e.g. "$4.28").
 * Prices are cached in sessionStorage so only one fetch per tab session.
 *
 * Endpoint updated 2026-06-23: now uses CoreBuild platform (rcp-sms-bot retired).
 */
(function () {
  var QBO_ENDPOINT = 'https://corebuild-platform-production.up.railway.app/api/qbo/items';
  var CACHE_KEY = 'rcp_qbo_prices';

  function applyPrices(priceMap) {
    document.querySelectorAll('[data-qbo-name]').forEach(function (el) {
      var name = el.getAttribute('data-qbo-name');
      if (priceMap[name] !== undefined) {
        // If element has rcp3-slide-price-num class, just set the number (no $ prefix)
        if (el.classList.contains('rcp3-slide-price-num')) {
          var decimals = el.classList.contains('rcp3-price-decimals') ? 2 : 0;
          el.textContent = priceMap[name].toFixed(decimals);
        } else {
          el.textContent = '$' + priceMap[name].toFixed(2);
        }
      }
    });

    // Also handle data-qbo-bundle: price x bundle qty
    document.querySelectorAll('[data-qbo-bundle]').forEach(function (el) {
      var raw = el.getAttribute('data-qbo-bundle');
      var parts = raw.split('|'); // "Rebar #4 (1/2\") 20'|150"
      var itemName = parts[0];
      var qty = parseFloat(parts[1]) || 1;
      if (priceMap[itemName] !== undefined) {
        var total = priceMap[itemName] * qty;
        el.textContent = '$' + total.toFixed(2) + ' / bundle';
      }
    });
  }

  function buildPriceMap(items) {
    var map = {};
    items.forEach(function (item) {
      var name = item.name || item.Name || '';
      var price = item.unitPrice || item.UnitPrice || 0;
      if (name && price > 0) {
        map[name] = price;
      }
    });
    return map;
  }

  function loadAndApply() {
    // Try cache first
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        applyPrices(JSON.parse(cached));
        return;
      }
    } catch (e) {}

    // Fetch live from CoreBuild platform
    fetch(QBO_ENDPOINT)
      .then(function (r) {
        if (!r.ok) throw new Error('QBO endpoint returned ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var items = Array.isArray(data) ? data : (data.items || []);
        if (items.length === 0) throw new Error('Empty QBO item list');
        var map = buildPriceMap(items);
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(map)); } catch (e) {}
        applyPrices(map);
      })
      .catch(function (err) {
        console.warn('[RCP] QBO pricing unavailable:', err);
        // Fallback: leave static prices in place — no blank cells
      });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAndApply);
  } else {
    loadAndApply();
  }
})();
